import React, { ChangeEvent, useCallback } from "react";
import { ChangeBase64 } from "../../../api/projectapi";
import "./css/index.css";
function ImageInput({
  title,
  sub,
  data,
  __update,
  isError,
  type,
}: {
  title: string;
  sub: string;
  data: string;
  __update: (type: string, payload: string | number) => void;
  isError: boolean;
  type: string;
}) {
  const __leadFile = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files;
      if (file) {
        Object.values(file).forEach((item) => {
          var reader = new FileReader();
          reader.onload = function (e) {
            const imageUrl = e?.target?.result;
            if (typeof imageUrl === "string") {
              ChangeBase64(imageUrl).then(({ state, data }) => {
                if (state) {
                  __update(type, data);
                } else {
                  alert("이미지 업로드 에러");
                }
              });
            }
          };
          reader.readAsDataURL(item);
        });
      }
    },
    [__update, type]
  );

  return (
    <div className="image-input">
      <div className="title">
        {title}
        <div
          className={`error-msg ${
            isError && data.length < 1 ? "active-error" : ""
          }`}
        >
          {isError && data.length < 1 ? "이미지를 등록해주세요" : undefined}
        </div>
      </div>
      <label>
        {data ? <img src={data} alt="" className="content-img" /> : undefined}
        <img
          src="/assets/common/image-input.svg"
          alt=""
          className="input-logo"
        />
        <div className="title">이미지 업로드</div>
        <div className="sub">{sub}</div>
        <input
          type="file"
          style={{ opacity: 0 }}
          multiple={false}
          accept="image/x-png,image/jpeg,image/jpg"
          onChange={__leadFile}
        />
      </label>
    </div>
  );
}

export default ImageInput;
